import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private readonly LAST_DIALOG_SHOWN_KEY = 'lastDialogShown';
  private readonly DIALOG_COOLDOWN_MS = 5 * 60 * 1000; // 5 minutes

  hasSeenAccountInfo(): boolean {
    const lastShown = localStorage.getItem(this.LAST_DIALOG_SHOWN_KEY);
    if (!lastShown) return false;

    const now = Date.now();
    const timeSinceLastShown = now - parseInt(lastShown, 10);

    // Return true if we're still in cooldown period
    return timeSinceLastShown < this.DIALOG_COOLDOWN_MS;
  }

  setSeenAccountInfo(): void {
    localStorage.setItem(this.LAST_DIALOG_SHOWN_KEY, Date.now().toString());
  }

  clearSeenAccountInfo(): void {
    localStorage.removeItem(this.LAST_DIALOG_SHOWN_KEY);
  }

  // Helper method to check remaining cooldown time
  getRemainingCooldownMs(): number {
    const lastShown = localStorage.getItem(this.LAST_DIALOG_SHOWN_KEY);
    if (!lastShown) return 0;

    const now = Date.now();
    const timeSinceLastShown = now - parseInt(lastShown, 10);
    const remaining = this.DIALOG_COOLDOWN_MS - timeSinceLastShown;

    return Math.max(0, remaining);
  }
}
